import React from 'react';
import { X, Check, ArrowRight } from 'lucide-react';
export function BeforeAfter() {
  const rows = [{
    before: 'Improvisabas',
    after: 'Abrís, leés y ejecutás'
  }, {
    before: 'Repetías estructuras',
    after: 'Seguís una progresión anual'
  }, {
    before: 'Planificabas cansado',
    after: 'Ahorrás horas cada semana'
  }, {
    before: 'Dudabas cada semana',
    after: 'Das clases con más autoridad'
  }, {
    before: 'No podías mostrar progreso real',
    after: 'Tus alumnos sienten y ven el progreso'
  }];
  return <section className="py-16 md:py-24 px-4 bg-surface/40 border-y border-zinc-800/60" data-id="element-22">
      <div className="max-w-5xl mx-auto" data-id="element-23">
        <div className="text-center mb-10 md:mb-14" data-id="element-24">
          <p className="text-primary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3" data-id="element-25">
            🔄 Antes vs. Después
          </p>
          <h2 className="text-2xl md:text-4xl font-extrabold leading-tight max-w-3xl mx-auto" data-id="element-26">
            No comprás solo PDFs.{' '}
            <span className="text-primary" data-id="element-27">
              Comprás orden para todo el año.
            </span>
          </h2>
        </div>

        {/* Two-column cards */}
        <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-10" data-id="element-28">
          {/* BEFORE */}
          <div className="bg-surface border border-red-500/20 rounded-2xl p-6 md:p-7" data-id="element-29">
            <div className="flex items-center gap-3 mb-5 pb-4 border-b border-red-500/20" data-id="element-30">
              <div className="w-10 h-10 rounded-xl bg-red-500/10 border border-red-500/30 flex items-center justify-center" data-id="element-31">
                <X className="w-5 h-5 text-red-400" data-id="element-32" />
              </div>
              <div data-id="element-33">
                <p className="text-[10px] md:text-xs uppercase tracking-widest text-red-400 font-bold" data-id="element-34">
                  Antes
                </p>
                <p className="text-base md:text-lg font-bold text-zinc-300" data-id="element-35">
                  Sin sistema
                </p>
              </div>
            </div>
            <ul className="space-y-3" data-id="element-36">
              {rows.map((r, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-37">
                  <X className="w-4 h-4 text-red-500 shrink-0 mt-1" data-id="element-38" />
                  <span className="text-zinc-400 text-sm md:text-base" data-id="element-39">
                    {r.before}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* AFTER */}
          <div className="relative bg-surface border-2 border-primary rounded-2xl p-6 md:p-7 shadow-[0_0_30px_rgba(74,222,128,0.15)]" data-id="element-40">
            <div className="absolute -top-3 right-5 md:right-6 hidden md:flex bg-primary text-black font-bold px-3 py-0.5 rounded-full text-[10px] items-center gap-1" data-id="element-41">
              <ArrowRight className="w-3 h-3" data-id="element-42" /> CON EL SISTEMA
            </div>
            <div className="flex items-center gap-3 mb-5 pb-4 border-b border-primary/20" data-id="element-43">
              <div className="w-10 h-10 rounded-xl bg-primary/15 border border-primary/30 flex items-center justify-center" data-id="element-44">
                <Check className="w-5 h-5 text-primary" data-id="element-45" />
              </div>
              <div data-id="element-46">
                <p className="text-[10px] md:text-xs uppercase tracking-widest text-primary font-bold" data-id="element-47">
                  Después
                </p>
                <p className="text-base md:text-lg font-bold text-white" data-id="element-48">
                  Con el Combo Completo
                </p>
              </div>
            </div>
            <ul className="space-y-3" data-id="element-49">
              {rows.map((r, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-50">
                  <Check className="w-4 h-4 text-primary shrink-0 mt-1" data-id="element-51" />
                  <span className="text-white text-sm md:text-base font-medium" data-id="element-52">
                    {r.after}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Emotional close */}
        <div className="text-center" data-id="element-53">
          <p className="text-base md:text-2xl text-zinc-200 font-bold leading-relaxed max-w-3xl mx-auto" data-id="element-54">
            Recuperás{' '}
            <span className="text-primary" data-id="element-55">tiempo, claridad mental</span> y{' '}
            <span className="text-primary" data-id="element-56">seguridad profesional.</span>
          </p>
        </div>
      </div>
    </section>;
}